import VerticalCollapse from './VerticalCollapse';

export default VerticalCollapse;
